import { render } from "./CurrentBalance.vue?vue&type=template&id=131b509a&scoped=true"
import script from "./CurrentBalance.vue?vue&type=script&lang=js"
export * from "./CurrentBalance.vue?vue&type=script&lang=js"

import "./CurrentBalance.vue?vue&type=style&index=0&id=131b509a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131b509a"]])

export default __exports__